export default __webpack_public_path__ + "static/media/portada.8d86cc5f.png";